import React, {Component} from "react";
import {Redirect} from 'react-router';

import withStyles from "@material-ui/core/styles/withStyles";
import Assignment from "@material-ui/icons/Assignment";
import FormControl from "@material-ui/core/FormControl";
import Switch from "@material-ui/core/Switch";
import InputLabel from "@material-ui/core/InputLabel";
import SearchComponentReport from "components/Search/AutoCompleteReportTemplate.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import api from "../../api/Api";
import {NavLink} from "react-router-dom";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/core components

import SearchComponent from "components/Search/AutoCompletePatient.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyName,
    verifyAlphaNum,
    verifyNumber, currentDate,
    verifyPhoneNumber,
    getReportTypes, isClinicMasterOrClinic, getClinicUserId, clinicmaster_id, dashboardRouter
} from '../../util/globalHelper'

// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import ReportUpload from "../CustomUpload/ReportUpload";
import Loader from '../../components/Loader'
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw, ContentState, convertFromHTML} from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'

var removeByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
        if (arr[i]
            && arr[i].hasOwnProperty(attr)
            && (arguments.length > 2 && arr[i][attr] === value)) {

            arr.splice(i, 1);

        }
    }
    return arr;
}


class CreateReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            save_template: false,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            doctorList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
            autoCompleteValue: "",
            companyNumber: "",
            companyNumberState: "",
            alert: null,
            open: true,
            generatedclinicmaster_id: "",
            propss: props,
            clinicmaster_id: "",
            doctor_id: "",
            clinic_id: "",
            patient: null,
            clinicsData: null,
            editorState: EditorState.createEmpty(),
            ref_by: "",
            age: "",
            remarks: "",
            ref_byState: "",
            remarksState: "",
            ageState: "",
            clinicDetail: null,
            secondaryNumber: [],
            secondaryNumberState: [],
            gender: "",
            templates: [],
            selectedPill: null
        };
        this.typeClick = this.typeClick.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.setReportTitle = this.setReportTitle.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.handleChangeSecondayNumber = this.handleChangeSecondayNumber.bind(this);
        this.changeSecondaryNumbers = this.changeSecondaryNumbers.bind(this);

    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    onEditorStateChange(editorState) {
        this.setState({
            editorState,
        });
    };

    handleImageUrl(url) {
        var reportCount = this.state.report_link.length > 0 ? this.state.report_link.length : "";
        this.setState({
            // imageurl: url,
            report_link: this.state.report_link.concat({
                "link": url,
                "type": `${this.state.simpleSelect !== "" ? this.state.simpleSelect : "Others"}`
            })
        }, () => {
            // this.setState({imageurl: ''})
        });
    }

    removeReport(url) {
        this.setState({report_link: this.state.report_link.splice(this.state.report_link.indexOf(this.state.report_link.find(item => item.link === url)), 1)})
    }

    changeExistingReport(url, preUrl) {
        let objIndex = this.state.report_link.length > 0 ? this.state.report_link.findIndex((obj => obj.link === preUrl)) : null;
        if (this.state.report_link.length > 0) {
            this.state.report_link[objIndex].link = url
        }
    }

    getSuggestionValue = (suggestion) => {
        this.setState({
            clickedId: suggestion._id,
            patient: suggestion,
            name: suggestion.user_id.name,
            nameState: 'success',
            contactNumber: suggestion.user_id.contact,
            contactNumberState: 'success',
            email: suggestion.user_id.email,
            emailState: 'success',
            age: suggestion.user_id.gender && suggestion.user_id.age !== "" ? suggestion.user_id.age : "",
            gender: suggestion.user_id.gender && suggestion.user_id.gender !== "" ? suggestion.user_id.gender === "male" ? "M" : "F" : ""
        });
        return suggestion.user_id.contact

    }

    setPhoneNumber(value) {
        this.setState({autoCompleteValue: value})
    }

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.patientID)
        this.setState({clickedId: this.props.id.match.params.patientID})

    }

    CallReadApi = (id) => {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({
            clinicMasterList: {},
            clinicmaster_id: clinicmaster_id(),
            clinic_id: getClinicUserId()
        });
        var postBody = {
            "clinic_master_id": clinicmaster_id(),
            "_id": id
        };
        if (id) {
            api.fetchPatientDetailsByClinicMasterAndPatientID(postBody).then(json => {
                this.setState({patientDetail: json.data.data[0]}, () => {
                    this.setState({
                        name: this.state.patientDetail.user_id.name, nameState: 'success',
                        autoCompleteValue: this.state.patientDetail.user_id.contact,
                        contactNumber: this.state.patientDetail.user_id.contact,
                        contactNumberState: 'success',
                        email: this.state.patientDetail.user_id.email,
                        emailState: 'success',
                    })
                })
            })
        }
        api.getAllDoctors().then(json => {
            this.setState({doctorList: json.data.data})
        });
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    setReportTitle(value) {
        this.setState({autoCompleteReportValue: value})
    }

    getReportTitleSuggestionValue = (suggestion) => {
        this.setState({
            report: suggestion,
            reportTitle: suggestion.title,
            simpleSelect: suggestion.type,
            templates: suggestion.templates
            // description: suggestion.description,
            // descriptionState: 'success',
            // editorState: EditorState.createWithContent(ContentState.createFromBlockArray((htmlToDraft(suggestion.html.replace(/10px;/gi, "12px"))).contentBlocks)),
//draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())).replace(/pt;/gi, "px;").replace(/↵/gi, "").replace(/12px;/gi, "10px;margin:0px;").replace(/<p>/gi, "<p style='font-size:10px;margin:0;'>"),
        });
        return suggestion.title

    };

    componentWillUnmount() {
        this.setState({
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
            gender: ""
        })

    }

    render() {
        const {classes} = this.props;
        const {clinicLis, clinicsData, clinicMasterList, editorState} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && (this.state.clinicsData[0] ? this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id : true) || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }
        if (this.state.clinicMasterList)
            return (
                <div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <h4 className={classes.cardTitle}>Create Report</h4>
                                    </CardText>

                                </CardHeader>
                                <CardBody>
                                    <form>
                                        <GridContainer>
                                            {isClinicMasterOrClinic() === "" ?
                                                <GridItem xs={12} sm={6} className="centerDiv">
                                                    <FormControl
                                                        fullWidth>
                                                        <InputLabel
                                                            htmlFor="clinicmaster_id">
                                                            Clinic Master
                                                        </InputLabel>
                                                        <Select
                                                            value={this.state.clinicmaster_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinicmaster_id",
                                                                id: "clinicmaster_id"
                                                            }}
                                                        >
                                                            <MenuItem
                                                                disabled
                                                            >
                                                                Select Clinic
                                                            </MenuItem>
                                                            {clinicMasterList.map((x) => {
                                                                return <MenuItem key={Math.random()}
                                                                                 style={{height: "1.8em"}}
                                                                                 value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                    <br/>
                                                </GridItem> : null}
                                            {isClinicMasterOrClinic() === "" || isClinicMasterOrClinic() ?
                                                <GridItem xs={12} sm={6} className="centerDiv">

                                                    {this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                                        <FormControl
                                                            fullWidth>
                                                            <InputLabel
                                                                htmlFor="clinic_id">
                                                                Clinic
                                                            </InputLabel>
                                                            <Select
                                                                value={this.state.clinic_id}
                                                                onChange={this.onChangeSelect}
                                                                inputProps={{
                                                                    name: "clinic_id",
                                                                    id: "clinic_id"
                                                                }}
                                                            >
                                                                <MenuItem
                                                                    disabled
                                                                >
                                                                    Select Clinic
                                                                </MenuItem>
                                                                {clinicsData.length > 0 ? clinicsData.map((x) => {
                                                                    return <MenuItem key={Math.random()}
                                                                                     style={{height: "1.8em"}}
                                                                                     value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                                }) : null}
                                                            </Select>
                                                        </FormControl> : null}
                                                </GridItem> : null}
                                            <GridItem xs={12} sm={6}>

                                                {this.props.id.match.params.patientID ? <CustomInput
                                                        labelText=" Phone Number"
                                                        success={this.state.contactNumberState === "success"}
                                                        error={this.state.contactNumberState === "error"}
                                                        id="url"
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event => this.change(event, "contactNumber", "phonenumber"),
                                                            value: this.state.contactNumber,

                                                        }}
                                                    /> :
                                                    <SearchComponent setPhoneNumber={this.setPhoneNumber}
                                                                     name={this.state.name}
                                                                     getSuggestionValue={this.getSuggestionValue}/>}
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <SearchComponentReport autoCompleteReportValue=""
                                                                       setReportTitle={this.setReportTitle}
                                                                       getReportTitleSuggestionValue={this.getReportTitleSuggestionValue}/>

                                                {/*<CustomInput*/}
                                                {/*labelText=" Report Title"*/}
                                                {/*success={this.state.reportTitleState === "success"}*/}
                                                {/*error={this.state.reportTitleState === "error"}*/}
                                                {/*id="reportTitle"*/}
                                                {/*formControlProps={{*/}
                                                {/*fullWidth: true,*/}
                                                {/*required: true*/}
                                                {/*}}*/}
                                                {/*inputProps={{*/}
                                                {/*onChange: event =>*/}
                                                {/*this.change(event, "reportTitle", "novalidation"),*/}

                                                {/*}}*/}
                                                {/*/>*/}
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Name"
                                                    success={this.state.nameState === "success"}
                                                    error={this.state.nameState === "error"}
                                                    id="name"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "name", "name"),
                                                        value: this.state.name,

                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}
                                                    style={{marginTop: 10}}>
                                                    <InputLabel
                                                        htmlFor="reportType"
                                                        className={classes.selectLabel}>
                                                        Report Type
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.simpleSelect}
                                                        onChange={this.handleSimple}
                                                        inputProps={{
                                                            name: "simpleSelect",
                                                            id: "simple-select"
                                                        }}
                                                    >
                                                        <MenuItem
                                                            disabled
                                                            classes={{
                                                                root: classes.selectMenuItem
                                                            }}>
                                                            Report Type
                                                        </MenuItem>
                                                        {getReportTypes().map(item => {
                                                            return <MenuItem key={Math.random()}
                                                                             classes={{root: classes.selectMenuItem}}
                                                                             style={{height: "1.8em"}}
                                                                             value={item}>{item}</MenuItem>
                                                        })})}
                                                    </Select>
                                                </FormControl>

                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>

                                                <CustomInput
                                                    labelText="Email"
                                                    success={this.state.emailState === "success"}
                                                    error={this.state.emailState === "error"}
                                                    id="email"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "email", "email"),
                                                        value: this.state.email,

                                                    }}
                                                />
                                            </GridItem>

                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Description"
                                                    success={this.state.descriptionState === "success"}
                                                    error={this.state.descriptionState === "error"}
                                                    id="name"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "description", "novalidation")
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} style={{marginTop: '10px'}}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}>
                                                    <InputLabel
                                                        htmlFor="simple-select"
                                                        className={classes.selectLabel}>
                                                        Gender
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.gender}
                                                        onChange={e => this.onChangeSelect(e)}
                                                        inputProps={{name: "gender", id: "gender"}}>
                                                        <MenuItem
                                                            disabled={true}
                                                            classes={{
                                                                root: classes.selectMenuItem,
                                                                selected: classes.selectMenuItemSelected
                                                            }}>
                                                            Select Gender
                                                        </MenuItem>
                                                        <MenuItem
                                                            classes={{root: classes.selectMenuItem}}
                                                            value="M">
                                                            Male </MenuItem>
                                                        <MenuItem
                                                            classes={{root: classes.selectMenuItem}}
                                                            value="F">
                                                            Female </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </GridItem>


                                            <GridItem xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={this.state.checkedA}
                                                            onChange={this.handleChange("checkedA")}
                                                            value="checkedA"
                                                            classes={{
                                                                switchBase: classes.switchBase,
                                                                checked: classes.switchChecked,
                                                                icon: classes.switchIcon,
                                                                iconChecked: classes.switchIconChecked,
                                                                bar: classes.switchBar
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classes.label
                                                    }}
                                                    label="No Payment Dues"
                                                />
                                            </GridItem>

                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Age"
                                                    success={this.state.ageState === "success"}
                                                    error={this.state.ageState === "error"}
                                                    id="age"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "age", "novalidation"),
                                                        value: this.state.age,

                                                    }}
                                                />
                                            </GridItem>

                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Ref By"
                                                    success={this.state.ref_byState === "success"}
                                                    error={this.state.ref_byState === "error"}
                                                    id="ref_by"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "ref_by", "novalidation"),
                                                        value: this.state.ref_by,

                                                    }}
                                                />
                                            </GridItem>


                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12}>
                                                {this.state.templates !== [] && this.state.templates.length > 0 ? this.state.templates.map((item, index) => {
                                                    return <a key={index}
                                                              href="#" onClick={() => {
                                                        this.setState({
                                                            description: item.description,
                                                            descriptionState: 'success',
                                                            editorState: EditorState.createWithContent(ContentState.createFromBlockArray((htmlToDraft(item.html.replace(/10px;/gi, "12px"))).contentBlocks)),
                                                            selectedPill: index
                                                        })
                                                    }}>  {this.state.selectedPill === index ?
                                                        <Button color="primary" round className={classes.marginRight}>
                                                            {item.remark && item.remark !== "" ? item.remark : "No Remark"}
                                                        </Button> :
                                                        <Button color="info" round className={classes.marginRight}>
                                                            {item.remark && item.remark !== "" ? item.remark : "No Remark"}
                                                        </Button>}</a>
                                                }) : null}
                                            </GridItem>
                                        </GridContainer>
                                        <GridItem>
                                            <GridContainer className={classes.justifyContentCenter}
                                                           style={{justifyContent: 'center', textAlign: 'center'}}>
                                                <div style={{minHeight: '100px'}}>
                                                    <Editor
                                                        editorState={editorState}
                                                        wrapperClassName="wrapper-class"
                                                        editorClassName="editor-class"
                                                        toolbarClassName="toolbar-class"
                                                        onEditorStateChange={this.onEditorStateChange}
                                                    />
                                                </div>
                                            </GridContainer>
                                            <br/><br/><br/>
                                        </GridItem>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>
                                                {this.state.secondaryNumber.map((name, index) => {
                                                    return <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="simple-select"
                                                            className={classes.selectLabel}>
                                                            Doctor
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={name}
                                                            onChange={event => this.changeSecondaryNumbers(event, "optional", index)}
                                                            inputProps={{name: "doctor_id", id: "secondaryNumber"}}>
                                                            <MenuItem
                                                                disabled={true}
                                                                classes={{
                                                                    root: classes.selectMenuItem,
                                                                    selected: classes.selectMenuItemSelected
                                                                }}>
                                                                Select Doctor
                                                            </MenuItem>
                                                            {this.state.clinicDetail !== null && this.state.clinicDetail.clinic_doctors ? this.state.clinicDetail.clinic_doctors.map(item => {
                                                                return <MenuItem key={Math.random()}
                                                                                 classes={{root: classes.selectMenuItem}}
                                                                                 value={item.user_id.name}>
                                                                    {item.user_id.name}  </MenuItem>
                                                            }) : this.state.doctorList.map(item => {
                                                                return <MenuItem
                                                                    key={Math.random()}
                                                                    value={item.user_details.name}
                                                                    classes={{
                                                                        root: classes.selectMenuItem
                                                                    }}>{item.user_details.name}
                                                                </MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                })}
                                                <Button block size="lg" color="warning"
                                                        onClick={(e) => this.addSecondaryContact(e)}>Add Doctor
                                                </Button>

                                            </GridItem>

                                            <GridItem xs={12} sm={3}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={this.state.save_template}
                                                            onChange={this.handleChange("save_template")}
                                                            value="save_template"
                                                            classes={{
                                                                switchBase: classes.switchBase,
                                                                checked: classes.switchChecked,
                                                                icon: classes.switchIcon,
                                                                iconChecked: classes.switchIconChecked,
                                                                bar: classes.switchBar
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classes.label
                                                    }}
                                                    label="Save as template"
                                                />
                                            </GridItem>
                                            {this.state.save_template ? <GridItem xs={12} sm={3}>
                                                <CustomInput
                                                    labelText="Remarks"
                                                    success={this.state.remarksState === "success"}
                                                    error={this.state.remarksState === "error"}
                                                    id="remarks"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "remarks", "novalidation"),
                                                        value: this.state.remarks,

                                                    }}
                                                />
                                            </GridItem> : null}
                                        </GridContainer>
                                    </form>
                                </CardBody>
                                <CardFooter>
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <Button block size="lg" color="warning" onClick={this.typeClick}>
                                                Save
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <NavLink to={dashboardRouter(`/reports/readReports`)}>
                                                <Button block size="lg" color="grey">
                                                    Cancel
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                    </GridContainer>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }


    addSecondaryContact() {
        let a = [""];
        let b = this.state.secondaryNumber.concat(a);
        this.setState({secondaryNumber: b})
    }

    handleChangeSecondayNumber(e, index) {
        this.state.secondaryNumber[index] = e.target.value;
        this.setState({secondaryNumber: this.state.secondaryNumber})
    }

    changeSecondaryNumbers(event, inputType, index) {
        let a = this.state.secondaryNumber.slice(); //creates the clone of the state
        a[index] = event.target.value;
        this.state.secondaryNumber[index] = event.target.value;
        this.setState({secondaryNumber: this.state.secondaryNumber});
        if ((event.target.value)) {
            let state = this.state;
            this.state.secondaryNumberState[index] = "success";
            this.setState(state);
        } else if (event.target.value === "" && inputType === "optional") {
            let state = this.state;
            this.state.secondaryNumberState[index] = "none";
            this.setState(state);
        } else {
            let state = this.state;
            this.state.secondaryNumberState[index] = "error";
            this.setState(state);
        }
    }

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    typeClick() {
        if (this.state.clinic_id === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the clinic!", color: "danger"});

        } else if (this.state.clickedId === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the patient details!", color: "danger"});

        } else if (this.state.clinicmaster_id === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the clinic master!", color: "danger"});

        } else if (this.state.ref_by === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the refernce details!", color: "danger"});

        } else if (this.state.name === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the patient details!", color: "danger"});

        } else if (this.state.clinic_id !== "" && this.state.name && this.state.autoCompleteValue != "" && this.state.clinicmaster_id && this.state.autoCompleteReportValue !== "" && this.state.secondaryNumber.length !== 0 && this.state.ref_by !== "") {
            var data = this.state.clickedId ? {
                "clinic_id": this.state.clinic_id,
                "patient_id": this.state.clickedId,
                "title": this.state.autoCompleteReportValue,
                "clinic_master_id": this.state.clinicmaster_id,
                "appointment_id": "",
                "amount": "",
                "date": currentDate(),
                "paid": this.state.checkedA,
                "gender": this.state.gender,
                "age": this.state.age,
                "remark": this.state.remarks,
                "description": this.state.description,
                "type": `${this.state.simpleSelect !== "" ? this.state.simpleSelect : "Others"}`,
                // "report_link": this.state.report_link,
                "ref_by": this.state.ref_by,
                "save_template": this.state.save_template,
                "docs": this.state.secondaryNumber.filter(function (value, index, arr) {
                    return value !== "";
                }).map(item => {
                    return {
                        "sign": this.state.doctorList.filter(a => a.user_details.name === item)[0].doctor_clinics.filter(b => b.clinic_id._id === this.state.clinic_id).signature ? this.state.doctorList.filter(a => a.user_details.name === item)[0].doctor_clinics.filter(b => b.clinic_id._id === this.state.clinic_id).signature : "Doctor",
                        "name": item
                    }
                }),
                "html": draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())).replace(/pt;/gi, "px;").replace(/↵/gi, "").replace(/12px;/gi, "10px;margin:0px;").replace(/<p>/gi, "<p style='font-size:10px;margin:0;'>"),
//a.data.filter(a=>a.user_details.name==="Rakesh Mittal")[0].doctor_clinics.filter(b=>b.clinic_id._id==="5ca4a5b579da16225b8c55ba").signature
            } : {
                "clinic_id": this.state.clinic_id,
                "name": this.state.name,
                "contact": this.state.autoCompleteValue,
                "email": this.state.email,
                "title": this.state.autoCompleteReportValue,
                "clinic_master_id": this.state.clinicmaster_id,
                "appointment_id": "",
                "amount": "",
                // "date": new Date().getTime(),
                "paid": this.state.checkedA,
                "gender": this.state.gender,
                "age": this.state.age,
                "remark": this.state.remarks,
                "description": this.state.description,
                "type": `${this.state.simpleSelect !== "" ? this.state.simpleSelect : "Others"}`,
                "ref_by": this.state.ref_by,
                "save_template": this.state.save_template,
                "date": currentDate(),
                "docs": this.state.secondaryNumber.filter(function (value, index, arr) {
                    return value !== "";
                }).map(item => {
                    return {
                        "sign": this.state.doctorList.filter(a => a.user_details.name === item)[0].doctor_clinics.filter(b => b.clinic_id._id === this.state.clinic_id).signature ? this.state.doctorList.filter(a => a.user_details.name === item)[0].doctor_clinics.filter(b => b.clinic_id._id === this.state.clinic_id).signature : "Doctor",
                        "name": item
                    }
                }),
                "html": draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())).replace(/pt;/gi, "px;").replace(/↵/gi, "").replace(/12px;/gi, "10px;margin:0px;").replace(/<p>/gi, "<p style='font-size:10px;margin:0;'>"),
            };
            api.createReportWithEditor(data).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Report Added Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/report/readReports`));
                }
            }).catch(error => {
                var msgcolor = {message: "Server Error!", color: "danger"};
                this.props.id.generateNotification(msgcolor);
            })
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

    handleChange = name => event => {
        this.setState({[name]: event.target.checked});
    };

}

export default withStyles(validationFormsStyle)(CreateReport);



// WEBPACK FOOTER //
// ./src/components/Reports/createReport.jsx